import React from "react";
import PageHeading from "../../components/PageHeading";
import { useQuery } from "react-query";
import adsServices from "../../services/ads";
import { Form } from "formik";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import FormikContainer from "../../components/Formik/FormikContainer";
import FieldContainer from "../../components/Formik/FieldContainer";
import DButton from "../../components/DButton";
import { Spinner } from "@chakra-ui/react";
import { toast } from "react-hot-toast";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
    messageAr: Yup.string().required("هذا الحقل مطلوب"),
    messageEn: Yup.string().required("هذا الحقل مطلوب"),
});
const Banner = ({ title }) => {
    const { data, isLoading, error } = useQuery("getBanner", () =>
        adsServices.getTextBanner()
    );
    const onSubmit = (values, { setSubmitting }) => {
        const msg = {
            message: JSON.stringify({
                ar: values.messageAr,
                en: values.messageEn,
            }),
        };
        adsServices
            .addTextBanner(msg)
            .then(res => {
                toast.success("تمت الاضافة بنجاح");
                setSubmitting(false);
            })
            .catch(err => {
                console.log(err);
                toast.error("فشلت العملية");
                setSubmitting(false);
            });
    };
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard className={isLoading ? "min-h-[400px] relative" : ""}>
                {isLoading ? (
                    <DSpinner />
                ) : (
                    <FormikContainer
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                        initialValues={{
                            messageAr: error
                                ? ""
                                : JSON.parse(data.data.message).ar,
                            messageEn: error
                                ? ""
                                : JSON.parse(data.data.message).en,
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <div className="grid md:grid-cols-2 gap-4">
                                    <FieldContainer
                                        name="messageAr"
                                        label="الرسالة النصية بالعربية"
                                        id="messageAr"
                                    />
                                    <FieldContainer
                                        name="messageEn"
                                        label="الرسالة النصية بالانجليزية"
                                        id="messageEn"
                                    />
                                </div>
                                <DButton
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={
                                        "flex justify-center items-center mx-auto text-white min-w-[150px]"
                                    }
                                >
                                    {isSubmitting ? <Spinner /> : "إضافة"}
                                </DButton>
                            </Form>
                        )}
                    </FormikContainer>
                )}
            </DCard>
        </div>
    );
};

export default Banner;
